module.exports = __webpack_public_path__ + "static/media/todo.70ada8ed.png";